import { defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
/** @public */ export const lokaliseProps = {
    apiKey: T.string
};
/** @internal */ export const lokaliseLocalizationProviderMigrations = defineMigrations({});
export const LokaliseLocalizationProviderInfo = {
    migrations: lokaliseLocalizationProviderMigrations,
    props: lokaliseProps
};
